<script setup>
const tokens = { used: 803, total: 2300 };
const audio = { used: 778, total: 1000 };

function pct(used, total) { return ((used / total) * 100).toFixed(1); }
function barColor(p) { return p < 50 ? '#7CCF00' : p < 80 ? '#FE9A00' : '#EF4444'; }
</script>

<template>
  <div class="sz-tokens-card">
    <div class="sz-tokens-header">
      <div>
        <h5 class="sz-tokens-title">Uso de tokens de IA</h5>
        <span class="sz-badge-live"><span class="sz-badge-dot" />&nbsp;Em tempo real</span>
      </div>
      <button class="sz-tokens-btn">Comprar tokens</button>
    </div>
    <div class="sz-tokens-bars">
      <!-- Tokens -->
      <div class="sz-bar-section">
        <div class="sz-bar-header">
          <span class="sz-bar-label">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12l4 6-10 13L2 9Z"/><path d="M11 3 8 9l4 13 4-13-3-6"/><path d="M2 9h20"/></svg>
            Tokens
          </span>
          <span class="sz-bar-pct">{{ pct(tokens.used, tokens.total) }}% <span class="sz-dot" :style="{ background: barColor(tokens.used / tokens.total * 100) }" /></span>
        </div>
        <div class="sz-track sz-track-green"><div class="sz-fill" :style="{ width: pct(tokens.used, tokens.total) + '%', background: 'linear-gradient(90deg, #236D23, #80B280)' }" /></div>
        <span class="sz-counter">{{ tokens.used }} de {{ tokens.total }} tokens</span>
      </div>
      <!-- Audio -->
      <div class="sz-bar-section">
        <div class="sz-bar-header">
          <span class="sz-bar-label">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3Z"/><path d="M19 10v2a7 7 0 01-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></svg>
            Áudio
          </span>
          <span class="sz-bar-pct">{{ pct(audio.used, audio.total) }}% <span class="sz-dot" :style="{ background: barColor(audio.used / audio.total * 100) }" /></span>
        </div>
        <div class="sz-track sz-track-orange"><div class="sz-fill" :style="{ width: pct(audio.used, audio.total) + '%', background: 'linear-gradient(90deg, #FE9A00, #FEF3C6)' }" /></div>
        <span class="sz-counter">{{ audio.used }} de {{ audio.total }} tokens de áudio</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sz-tokens-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px; }
.sz-tokens-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; }
.sz-tokens-title { font-size: 16px; font-weight: 600; color: #1a1a1a; margin: 0 0 4px; }
.sz-badge-live { display: inline-flex; align-items: center; gap: 5px; padding: 2px 8px; border-radius: 9999px; background: rgba(44,123,44,0.12); font-size: 11px; font-weight: 500; color: #2C7B2C; }
.sz-badge-dot { width: 6px; height: 6px; border-radius: 50%; background: #2C7B2C; }
.sz-tokens-btn { padding: 6px 14px; border: 1px solid #e5e7eb; border-radius: 8px; background: #fff; font-size: 13px; font-weight: 500; cursor: pointer; color: #374151; }
.sz-tokens-btn:hover { background: #f9fafb; }
.sz-tokens-bars { display: flex; gap: 24px; }
.sz-bar-section { flex: 1; }
.sz-bar-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
.sz-bar-label { display: flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 500; color: #374151; }
.sz-bar-pct { font-size: 12px; color: #6b7280; display: flex; align-items: center; gap: 4px; }
.sz-dot { width: 8px; height: 8px; border-radius: 50%; }
.sz-track { height: 10px; border-radius: 8px; overflow: hidden; border: 1px solid rgba(56,142,60,0.24); }
.sz-track-green { background: #EEF6F0; }
.sz-track-orange { background: rgba(254,243,198,0.32); border-color: rgba(255,204,20,0.24); }
.sz-fill { height: 100%; border-radius: 8px; transition: width 1s ease; }
.sz-counter { font-size: 11px; color: #9ca3af; margin-top: 4px; display: block; }
</style>

<style>
/* Dark mode */
.dark .sz-tokens-card { background: #1F2125; border-color: rgba(255,255,255,0.1); }
.dark .sz-tokens-title { color: #EDEEEF; }
.dark .sz-tokens-subtitle { color: #9CA3AF; }
.dark .sz-tokens-label { color: #D4D4D4; }
.dark .sz-tokens-value { color: #E5E7EB; }
.dark .sz-tokens-bar-bg { background: #363840; }
.dark .sz-track { border-color: rgba(255,255,255,0.1); }
.dark .sz-track-green { background: #1A2E1A; }
.dark .sz-track-orange { background: #2E2A1A; border-color: rgba(255,204,20,0.15); }
.dark .sz-bar-label { color: #D4D4D4; }
.dark .sz-bar-pct { color: #9CA3AF; }
.dark .sz-counter { color: #6B7280; }
</style>
